import React from "react";
import Container from "./containerUserFeedBack";
import { checkIcon } from "../Images";
import ResourceTable from "./ResourceTable";
import "./feedback.css";
class UserContainer extends React.Component {
  render() {
    const { isMobile, logo, data } = this.props;
    return (
      <Container
        headtext="SHARE RESOURCE SPECIFIC FEEDBACK"
        data={data}
        isMobile={isMobile}
        logo={logo}
        subtext="If you think any resource has performed above or below the expectation,you can also rate them here."
      >
        <div className={isMobile ? "containerSM" : "containerMD"}>
          <ResourceTable isMobile={isMobile} data={data} />
        </div>
      </Container>
    );
  }
}

export default UserContainer;
